module.exports = __webpack_public_path__ + "static/media/tm.b13d1440.svg";